import React, { FC } from 'react';
import { MotifCheckbox } from '@ey-xd/motif-react';

type CheckboxProps = {
    id: string;
    checked: boolean;
    name: string;
    value: string;
    disabled?: boolean;
    onChange?: (...args: any[]) => any;
    children?: React.ReactNode;
    className?: string;
    indeterminate?: boolean;
};
const Checkbox: FC<CheckboxProps> = ({
    id,
    checked,
    name,
    value,
    disabled,
    onChange,
    className,
    indeterminate,
    ...other
}: CheckboxProps) => (
    <MotifCheckbox
        id={id}
        checked={checked}
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
        className={className}
        indeterminate={indeterminate}
        {...other}
    />
);
export default Checkbox;
